import { render, staticRenderFns } from "./Dcp.vue?vue&type=template&id=34c21bce&"
import script from "./Dcp.vue?vue&type=script&lang=js&"
export * from "./Dcp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports